import { Cart, RecoveredCart } from '@pegasus/cart';

export const SET_CART = 'cart/SET_CART';

export const SET_RECOVERED_CART = 'cart/SET_RECOVERED_CART';

export const RESET_CART = 'cart/RESET_CART';

export const SET_CART_LOADING = 'cart/SET_CART_LOADING';

export const RESERVE_CART_START = 'cart/RESERVE_CART_START';

export const RESERVE_CART_SUCCESS = 'cart/RESERVE_CART_SUCCESS';

export const RESERVE_CART_FAILURE = 'cart/RESERVE_CART_FAILURE';

export const UPDATE_CART_PARTIAL = 'cart/UPDATE_CART_PARTIAL';

export const setCart = (cart: Cart) => ({
    type: SET_CART as typeof SET_CART,
    payload: {
        cart,
    },
});

export const setRecoveredCart = (recoveredCart: RecoveredCart) => ({
    type: SET_RECOVERED_CART as typeof SET_RECOVERED_CART,
    payload: {
        recoveredCart,
    },
});

export const resetCart = () => ({
    type: RESET_CART as typeof RESET_CART,
});

export const setCartLoading = (isLoading: boolean) => ({
    type: SET_CART_LOADING as typeof SET_CART_LOADING,
    payload: { isLoading },
});

export const reserveCartStart = () => ({
    type: RESERVE_CART_START as typeof RESERVE_CART_START,
});

export const reserveCartSuccess = (cart: Cart) => ({
    type: RESERVE_CART_SUCCESS as typeof RESERVE_CART_SUCCESS,
    payload: {
        cart,
    },
});

export const reserveCartFailure = (error: string) => ({
    type: RESERVE_CART_FAILURE as typeof RESERVE_CART_FAILURE,
    payload: {
        error,
    },
});

export const updateCartPartial = (updates: Partial<Cart>) => ({
    type: UPDATE_CART_PARTIAL as typeof UPDATE_CART_PARTIAL,
    payload: {
        updates,
    },
});

export type Actions =
    | ReturnType<typeof resetCart>
    | ReturnType<typeof setCart>
    | ReturnType<typeof setRecoveredCart>
    | ReturnType<typeof setCartLoading>
    | ReturnType<typeof updateCartPartial>
    | ReturnType<typeof reserveCartStart>
    | ReturnType<typeof reserveCartSuccess>
    | ReturnType<typeof reserveCartFailure>;
